import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAnalogueFilter } from './types';
import { ITreeElement } from '../../helpers/types/tree';
import { GetTagAttributeAllowedValues, GetDropdownAllTagAttributeAllowedValues } from '../../api/sidebar/sideBarService';

// Analogue-specific thunks for tag attribute allowed values
export const GetAnalogueTagAttributeAllowedValuesThunk = createAsyncThunk(
  'analogueFilterOptions/GetAnalogueTagAttributeAllowedValues', 
  async (filter: { 
    tagAttributeId: string, 
    filters: IAnalogueFilter[], 
    workspaceId: string, 
    analogueWorkspaceId: string,
    props: ITreeElement 
  }, thunkAPI) => {
    // Use the same API endpoint but with analogue-specific parameters
    const response = await GetTagAttributeAllowedValues({
      tagAttributeId: filter.tagAttributeId,
      filters: filter.filters as any, // Cast to match the expected interface
      workspaceId: filter.workspaceId // Use analogue workspace ID
    }, thunkAPI);
    return response;
  }
);

export const GetAnalogueDropdownAllTagAttributeAllowedValuesThunk = createAsyncThunk(
  'analogueFilterOptions/GetAnalogueDropdownAllTagAttributeAllowedValues', 
  async (filter: { 
    tagAttributeId: string, 
    filters: IAnalogueFilter[], 
    workspaceId: string, 
    analogueWorkspaceId: string,
    props: ITreeElement 
  }, thunkAPI) => {
    // Use the same API endpoint but with analogue-specific parameters
    const response = await GetDropdownAllTagAttributeAllowedValues({
      tagAttributeId: filter.tagAttributeId
    }, thunkAPI);
    return response;
  }
); 